import React from 'react';
import { useTranslation } from 'react-i18next';

const FullPageLoading = () => {
  const { t } = useTranslation('common');
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto" />
        <p className="mt-4 text-gray-600">{t('loading')}</p>
      </div>
    </div>
  );
};

export default FullPageLoading;
